import { z } from "zod";
import { CompanySchema } from "./Company";
import { ProductSchema } from "./Product";
import { UserSchema } from "./User";

export const ServicedProductFieldsSchema = z.object({
  id: z.number(),
  serialCode: z.string(),
  date: z.string(),
  isActive: z.boolean(),
  modificationDate: z.string(),
  importTyp: z.string(),
  importCode: z.string(),
  address: z.string(),
  product: ProductSchema,
  company: CompanySchema,
  creatorUser: UserSchema,
  place: z.any(),
  children: z.any(),
  parent: z.any(),
});
export const PartialServicedProductFieldsSchema =
  ServicedProductFieldsSchema.deepPartial();

export const ServicedProductExtraFieldsSchema = z.object({
  fullName: z.string(),
  attributes: z.array(z.any()), // TODO: define schema
  relations: z.object({
    tasks: z.array(z.any()),
    odbcReports: z.array(z.any()),
    commissions: z.array(z.any()),
    campaignOpportunities: z.array(z.any()),
  }),
});
export const PartialServicedProductExtraFieldsSchema =
  ServicedProductExtraFieldsSchema.deepPartial();

export const ServicedProductSchema = z.intersection(
  ServicedProductFieldsSchema,
  ServicedProductExtraFieldsSchema
);

export type ServicedProductFields = z.infer<typeof ServicedProductFieldsSchema>;
export type PartialServicedProductFields = z.infer<
  typeof PartialServicedProductFieldsSchema
>;
export type ServicedProductExtraFields = z.infer<
  typeof ServicedProductExtraFieldsSchema
>;
export type PartialServicedProductExtraFields = z.infer<
  typeof PartialServicedProductExtraFieldsSchema
>;
export type ServicedProduct = z.infer<typeof ServicedProductSchema>;
